import { CaseListItem } from 'queries/cases/types';
import { useTranslation } from 'react-i18next';
import './StagePanel.scss';
import { processStageData } from './helper';

type StageSummaryPanelProps = {
  stageDataToCount: Partial<CaseListItem>[];
  activeItems?: string[];
  onChange?: (selectedValue: string) => void;
};

const StageSummaryPanel = ({ stageDataToCount, activeItems, onChange }: StageSummaryPanelProps) => {
  const { t } = useTranslation();
  const stageCounts = processStageData(stageDataToCount);

  return (
    <div className="stage-box" data-testid="stage-summary-panel">
      <div>
        <div className="box-title" data-testid="stage-title">
          {t('case:status.title')}
        </div>
      </div>
      <div className="stage-items" data-testid="stage-items">
        {Object.keys(stageCounts).map((item) => (
          <div
            className={`stage-outer-item ${item} ${activeItems?.includes(item) && 'stage-active'} `}
            key={item}
            onClick={() => {
              onChange && onChange(item);
            }}
            data-testid={`stage-item-${item}`}
          >
            <strong className="box-value" data-testid="stage-value">
              {stageCounts[item]}
            </strong>
            <div className="box-caption" data-testid="stage-caption">
              {t(`case:status.${item}`)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StageSummaryPanel;
